export default __webpack_public_path__ + "static/media/saint_aubin4.ef871f7b.jpg";